import styled from '@emotion/styled'
import { Stack } from 'components/Stack'
import { colors } from 'utils/colors'
import { pxToRem, BREAKPOINTS } from 'utils/styled'

export const SContentContainer = styled(Stack)`
  align-items: center;
  position: relative;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: -${pxToRem(72)}rem;
    left: -${pxToRem(110)}rem;
    bottom: -${pxToRem(72)}rem;
    right: calc(50% - ${pxToRem(150)}rem);

    @media ${BREAKPOINTS.LG.max} {
      display: none;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    & > *:not(:last-child) {
      margin-right: 0;
    }
  }
`

export const SDot = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  background: ${colors.gray[500]};
  border-radius: 50%;
`
